module.exports = __webpack_public_path__ + "img/card1.9c64f50d.png";